<template>
  <a
    v-on:click="$emit('click')"
    :class="{ 'action-link': !color,
                'action-link-secondary': color === 'secondary-color' }"
  >
    <font-awesome-icon
      v-if="iconPosition === 'left'"
      class="action-link-icon"
      :icon="icon"
    />
    <span class="action-link-label">{{ label }}</span>
    <font-awesome-icon
      v-if="iconPosition === 'right'"
      class="action-link-icon"
      :icon="icon"
    />
  </a>
</template>

<script>
export default {
    /** Simple link with animation on hover
    Can also be used as a css class or mixin
    Examples : http://avoranfix.hespul.org/pages/viewpage.action?pageId=10191751
    */
    name: 'SectionTitle',
    components: {},
    props: {
        label: { default: '', type: String },
        icon: { default: '', type: String },
        iconPosition: { default: 'left', type: String },
        /** Colors enables :
         *  default -> primary-color
         *  'secondary-color'
         */
        color: { default: '', type: String },
    },
};
</script>

<style lang='stylus' scoped>
</style>
